import { render, staticRenderFns } from "./WizardSectionPage.vue?vue&type=template&id=f2238994&scoped=true&lang=pug&"
import script from "./WizardSectionPage.vue?vue&type=script&lang=ts&"
export * from "./WizardSectionPage.vue?vue&type=script&lang=ts&"
import style0 from "./WizardSectionPage.vue?vue&type=style&index=0&id=f2238994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2238994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2238994')) {
      api.createRecord('f2238994', component.options)
    } else {
      api.reload('f2238994', component.options)
    }
    module.hot.accept("./WizardSectionPage.vue?vue&type=template&id=f2238994&scoped=true&lang=pug&", function () {
      api.rerender('f2238994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard-pages/WizardSectionPage.vue"
export default component.exports